import { Plus } from 'lucide-react'
import { Button } from '../../../../components'

interface LeavePoliciesHeaderCardProps {
  onAddLeavePolicy: () => void
}

export function LeavePoliciesHeaderCard({ onAddLeavePolicy }: LeavePoliciesHeaderCardProps) {
  return (
    <div className="bg-white rounded-2xl border border-slate-200 p-5 flex flex-col sm:flex-row sm:items-center justify-between gap-4 min-w-0 font-sans">
      <div className="min-w-0">
        <h2 className="text-base font-bold text-slate-900">Leave Policies</h2>
        <p className="text-xs text-slate-500 mt-0.5">
          Define leave entitlements and assign policies to employee groups across faculties.
        </p>
      </div>

      <Button
        type="button"
        variant="primary"
        size="sm"
        icon={<Plus className="h-4 w-4" />}
        onClick={onAddLeavePolicy}
        className="bg-teal-900 hover:bg-teal-950 text-white rounded-lg px-4 py-2.5 text-xs font-semibold shrink-0 whitespace-nowrap cursor-pointer border-none flex items-center gap-2"
      >
        Add Leave Policy
      </Button>
    </div>
  )
}
